"use client";

import React, { useState } from "react";
import ArrowIcon from "../uiDecor/arrowFaq";
import BottomCurves from "../curves/bottomCurves";
import FloatingArrow from "../uiDecor/floatingArrow";

type FAQItem = {
  id: number;
  heading: string;
  description: string;
};

type FAQProps = {
  data: {
    name: string;
    content: FAQItem[];
    waveBgColor?: {
      id: number;
      waveBgColor: string;
    };
  };
};

export default function Faqs({ data }: FAQProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="bg-rainbow px-8 sm:px-6 md:px-10 lg:px-24 py-24 md:py-32 lg:py-40 lg:pb-64">
      <div className="max-w-[93rem] mx-auto flex flex-col lg:flex-row md:gap-6 lg:gap-16">
        <div className="w-3/4 lg:w-[38%]">
          <h2 className="text-[#851BED] font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight">
            {data.name}
          </h2>
        </div>

        <div className="lg:w-[62%] flex flex-col divide-y divide-gray-300">
          {data.content.map((item, index) => {
            const isOpen = index === activeIndex;
            return (
              <div
                key={item.id}
                onClick={() => toggle(index)}
                className="py-2 md:py-4 cursor-pointer transition-all"
              >
                <div className="flex justify-between items-center gap-4 min-h-[64px] w1090:min-h-0">
                  <h3 className="text-[1.2rem] leading-[1.5rem] sm:text-xl 2xl:text-3xl font-semibold text-gray-800 select-none">
                    {item.heading}
                  </h3>
                  <div className="w-4 h-4 xs:w-5 xs:h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 flex-shrink-0">
                    <ArrowIcon
                      color={isOpen ? "#851BED" : "#000000"}
                      rotate={isOpen}
                    />
                  </div>
                </div>

                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen
                      ? "max-h-96 mt-3 opacity-100"
                      : "max-h-0 opacity-0"
                    }`}
                >
                  <p className="text-base sm:text-lg md:text-xl text-gray-700 font-normal mt-2 select-none whitespace-pre-line">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <BottomCurves
        color={data.waveBgColor?.waveBgColor || "dark purple"}
        direction="right"
        className="z-10"
      />
      <FloatingArrow
        direction="left"
        className="top-0 left-[10.625vw]"
        wrapText="faqs"
      />
    </section>
  );
}
